var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 6.66659H16.6667V4.99992H3.33335V6.66659ZM1.66669 4.99992C1.66669 4.54159 1.82988 4.14922 2.15627 3.82284C2.48266 3.49645 2.87502 3.33325 3.33335 3.33325H16.6667C17.125 3.33325 17.5174 3.49645 17.8438 3.82284C18.1702 4.14922 18.3334 4.54159 18.3334 4.99992V9.99992H3.33335V14.9999H6.75002V16.6666H3.33335C2.87502 16.6666 2.48266 16.5034 2.15627 16.177C1.82988 15.8506 1.66669 15.4583 1.66669 14.9999V4.99992ZM12.4584 18.3333L8.91669 14.7916L10.0834 13.6249L12.4584 15.9583L17.1667 11.2499L18.3334 12.4583L12.4584 18.3333ZM3.33335 4.99992V14.9999V11.2499V13.6041V4.99992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessors);
export default __webpack_public_path__ + "static/media/processors.c14795e40cb818267985c5994ef995a3.svg";
export { ForwardRef as ReactComponent };